import { useEffect, useState } from "react";
import SmCalDayTitle from "./SmCalDayTitle";
import getDaysInMonth from "../../hooks/getAllDaysInMonth";
import SmCalDay from "./SmCalDay";
import { useContext} from "react";
import { ThemeContext } from "../../context/ThemeContext";

const days = [
    {
        name: "Sun"
    },
    {
        name: "Mon"
    },
    {
        name: "Tues"
    },
    {
        name: "Wed"
    },
    {
        name: "Thurs"
    },
    {
        name: "Fri"
    },
    {
        name: "Sat"
    },
]
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function SmallCalendar({useRange, onChange}){
    const dayTitles = days.map(day => <SmCalDayTitle key={day.name} name={day.name}/>)
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);
    const theme = useContext(ThemeContext);
    const {dark} = theme;
    const [selectedDay, setSelectedDay] = useState("none");
    const [dateRange, setDateRange] = useState([])

    useEffect(()=>{
        if(useRange){
        }else{
        }
    },[selectedDay, dateRange, useRange, onChange])

    function next() {
        if(month === 11){
            setMonth(0);
            setYear(prevState => (prevState+1));
        }
        else{
            setMonth(prevState => (prevState+1));
        }
    }
    
    function previous() {
        if(month === 0){
            setMonth(11);
            setYear(prevState => (prevState-1));
        }
        else{
            setMonth(prevState => (prevState-1));
        }
    }

    var getDaysArray = function(start, end) {
        for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
            arr.push(new Date(dt).toString());
        }
        return arr;
    };

    function selectManager(day){
        if(!useRange){
            setDateRange([]);
            if(day === selectedDay){
                setSelectedDay("none")
                onChange("none", false);
            }
            else{
                setSelectedDay(day);
                onChange(day, false);
            }
        }
        else{
            if(selectedDay === "none"){
                setSelectedDay(day);
                onChange(day, false);
            }
            else{
                if(dateRange.length === 0){
                    var first = selectedDay;
                    var daylist = getDaysArray(new Date(first),new Date(day));
                    setDateRange(daylist);
                    onChange(daylist, true);
                }
                else{
                    setDateRange([])
                    setSelectedDay("none");
                    onChange([], true);
                }
            }
        }
    }

    let firstDay = (new Date(year, month)).getDay();
    let daysInMonth = getDaysInMonth(month, year);

    const populatedMonth = [];

    // creating all cells
    let date = 1;
    let extra = 1;
    for (let i = 0; i < 42; i++) {
        if(i >= firstDay && i - firstDay<daysInMonth.length)
        {
                populatedMonth.push(<SmCalDay key={i} id={new Date(year,month,date)} day={date} onClick={selectManager} range={useRange} act={useRange ? dateRange : selectedDay}/>)
            
            date++;
        }
        else{
            if(i<firstDay){
                let m = month -1;
                let y = year;
                if(m ===-1){
                    m=11;
                    y = year -1;
                }
                let monthLength = getDaysInMonth(m, y);
                let d = monthLength.length - firstDay +i;
                populatedMonth.push(<SmCalDay key={i} id={new Date(y,m,d)} day={d} current={false}/>)
            }else{
                let m = month +1;
                let y = year;
                if(m === 11){
                    m=1;
                    y= year+1;
                }
                populatedMonth.push(<SmCalDay key={i} id={new Date(y,m,extra)} day={extra} current={false}/>)
                extra++;
            }
        }
        if (date === today.getDate() && year === today.getFullYear() && month === today.getMonth()) {
                    
        } // color today's date
    }

    return(
        <div className={`w-full border border-solid rounded-lg ${dark? "border-neutral-300 bg-neutral-600": "border-neutral-300 bg-white"}`}>
    <div className='w-full max-w-lg px-6 pb-4 pt-4 mx-auto rounded-2xl flex flex-col'>
        <div className="flex justify-between px-2">
<div className="-rotate-90 cursor-pointer" onClick={previous}>
    <svg className={`stroke-accent hover:stroke-neutral-900`} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.001 6L6.00098 1L1.00098 6"   strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
 </div>
<span className={`uppercase text-sm font-semibold  ${dark? "text-white" : "text-neutral-900"}`}>{months[month] + " - " + year}</span>
<div className="rotate-90 cursor-pointer" onClick={next}>
    <svg className={`stroke-accent hover:stroke-neutral-900`} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.001 6L6.00098 1L1.00098 6"   strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
</div>
</div>
       <div className="px-2 ">
    </div>
 <div className="grid grid-cols-7 justify-between font-medium uppercase text-xs pt-4  ">
       {dayTitles} 
 </div>

 <div className="grid justify-between font-medium text-sm pt-2 grid-cols-7">
        {populatedMonth}
 </div>
 </div>
</div>
    )
}

export default SmallCalendar;